import React, { Component } from 'react';

export class TotePlacement extends Component {
    render() {
        var POInfo = this.props.POInfo;
        var repickCart = (!this.props.allItemsReceived || !POInfo.readyToBill);
        var shippingCart = POInfo.shippingCart;
        var cartName = shippingCart;
        if (repickCart) {
            cartName = "Repick";
        }
        if (this.props.orderHadErrors) {
            cartName = "Nametag Redo";
        }
        return (
            <div className="place-tote">
                <h1>Place Tote on {cartName} Cart</h1>
                {
                    !this.props.orderHadErrors && !POInfo.readyToBill
                    &&
                    <h2>There are additional items not from this vendor that need to be picked</h2>
                }
                <button className="place-tote-button" onClick={this.props.resetState}>OK</button>
            </div>
        );
    }
}